export default "__VITE_ASSET__Bjl_pMdg__"